import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { Links } from "utils/pageLinkNames";

const RequireAuth = ({ isAuthenticated }) => {
  const location = useLocation();
  const { appConstants, license } = useSelector((state) => state.service);
  const LICENSE_STATUS = appConstants?.allTypes?.LICENSE_STATUS || {};

  if (appConstants?.resetPassword && location.pathname !== Links.RESET_PASSWORD) {
    return <Navigate to={Links.RESET_PASSWORD} state={{ from: location }} replace />;
  }

  const settingsPath = `/${Links.SETTINGS}`;

  const isExpired =
    license?.licenseStatus === LICENSE_STATUS.EXPIRED || license?.licenseStatus === "Expired";
  if (isAuthenticated && isExpired && location.pathname !== settingsPath) {
    return <Navigate to={settingsPath} state={{ from: location }} replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: location }} replace />;
};
export default RequireAuth;
